"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.linkCtaPropType = exports.imagePropType = exports.featurePropType = exports.dataPropType = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var imagePropType = _propTypes["default"].shape({
  image: _propTypes["default"].string,
  altText: _propTypes["default"].string
});

exports.imagePropType = imagePropType;

var linkCtaPropType = _propTypes["default"].shape({
  URL: _propTypes["default"].string,
  label: _propTypes["default"].string
});

exports.linkCtaPropType = linkCtaPropType;

var featurePropType = _propTypes["default"].shape({
  image: imagePropType,
  description: _propTypes["default"].string
});

exports.featurePropType = featurePropType;

var dataPropType = _propTypes["default"].shape({
  resourceType: _propTypes["default"].string,
  componentLabel: _propTypes["default"].string,
  heading1: _propTypes["default"].string,
  heading2: _propTypes["default"].string,
  heading3: _propTypes["default"].string,
  textBlock: _propTypes["default"].string,
  textBlockPosition: _propTypes["default"].string,
  featureBlock: _propTypes["default"].arrayOf(featurePropType),
  cta: linkCtaPropType,
  link: linkCtaPropType,
  image: imagePropType
});

exports.dataPropType = dataPropType;